import { render, staticRenderFns } from "./ModeOfTransport.vue?vue&type=template&id=2c69dcb3&"
import script from "./ModeOfTransport.vue?vue&type=script&lang=js&"
export * from "./ModeOfTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports